<template>
  <div class="container-fluid">
    <div class="invoice row">
      <card>
        <div class="card__title">
          <h4>{{ $t('Documents') }}</h4>
        </div>
        <div class="card__body">
          <div class="alert alert-danger" v-if="error">
              <p>{{ error }}</p>
          </div>
          <el-table
            :data="orders"
            class="orders-table"
            v-loading="loading"
            :default-sort = "{prop: 'order_date', order: 'descending'}"
            @sort-change="sort">
            <el-table-column sortable="custom" min-width="150" prop="doc_name" :label="$t('Title')">
            </el-table-column>
            <el-table-column sortable="custom" min-width="150" prop="order_date" :label="$t('Date')">
            </el-table-column>
            <el-table-column sortable="custom" prop="re_summ" min-width="200" :label="$t('Sum')">
              <template slot-scope="scope">
                {{ formatPrice(scope.row.re_summ) + ' ' + scope.row.curr_symbol }}
              </template>
            </el-table-column>
            <el-table-column header-align="right">
              <div slot-scope="scope" class="text-right">
                <el-tooltip :content="$t('Download')" :open-delay="300" placement="top">
                  <el-button
                    type="primary"
                    circle
                    icon="el-icon-download"
                    @click.prevent="downloadOrder(scope.$index, scope.row)"
                    size="small"
                  >
                  </el-button>
                </el-tooltip>
              </div>
            </el-table-column>
            <div slot="empty" v-if="!orders">
              {{ $t('No invoices')}}
            </div>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pgnum"
            :page-sizes="pageSizes"
            :page-size="pgsize"
            layout="prev, pager, next, ->, sizes, total"
            :total="total"
            class="orders-pagination">
          </el-pagination>
          <iframe id="hiddenDownloader" src="" />
        </div>
      </card>
    </div>
    <div class="row">

    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Pagination, Button } from 'element-ui'
import axios from 'axios'
import lang from 'element-ui/lib/locale/lang/ru-RU'
import locale from 'element-ui/lib/locale'
import number from './mixins/number'

locale.use(lang)

export default {
  name: 'Invoice',
  mixins: [number],
  data () {
    return {
      orders: null,
      pageSizes: [10, 20, 30, 40, 50, 100],
      pgnum: 1,
      pgsize: 10,
      error: '',
      loading: false,
      total: 0,
      sortColumn: 'order_date',
      sortOrder: 'desc'
    }
  },
  created () {
    this.fetchOrders()
  },
  methods: {
    handleSizeChange(val) {
      this.pgnum = 1
      this.pgsize = val
      this.fetchOrders()
    },
    handleCurrentChange(val) {
      this.pgnum = val
      this.fetchOrders()
    },
    fetchOrders() {
      this.loading = true
      axios.get('orders', {
        params: {
          pgnum: this.pgnum,
          pgsize: this.pgsize,
          sortColumn: this.sortColumn,
          sortOrder: this.sortOrder
        }
      }).then(promise => {
        this.orders = promise.data.results
        this.total = promise.data.total
        this.loading = false
      }).catch(error => {
        console.log(error.response.data.error)
      })
    },
    sort(param) {
      if (param.column !== null) {
        this.sortColumn = param.prop
        this.sortOrder = param.order === 'descending' ? 'desc' : 'asc'
      } else {
        this.sortColumn = 'order_date'
        this.sortOrder = 'desc'
      }
      this.fetchOrders()
    },
    downloadOrder(index, row) {
      const iframe = document.getElementById('hiddenDownloader')
      const url = process.env.VUE_APP_API_URL + 'api/'
      const action = 'orders/download'
      const params = {
        file_path: row.file_name,
        mime: row.doc_uploadext
      }
      const esc = encodeURIComponent
      const query = Object.keys(params)
        .map(k => esc(k) + '=' + esc(params[k]))
        .join('&')
      const src = url + action + '?' + query
      iframe.src = src
    }
  },
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Pagination.name]: Pagination
  }
}

</script>

<style scoped>
  #hiddenDownloader {
    display: none
  }
  .orders-table {
    margin-bottom: 10px;
  }
  .orders-pagination >>> .el-input__inner {
    margin: 0 !important;
  }
  .orders-pagination >>> .el-input {
    width: 140px !important;
  }
</style>
